// This is the mapping of country codes to currency codes and icons
// This doesn't primarily associate the country to the currency, but just a basic mapping.
// The real priceObject should come from stripe-country collection
export const StripeCountryCurrency = {
  // USD countries
  US: { country: 'US', currency: 'usd', symbol: '$' },
  // GBP countries
  GB: { country: 'GB', currency: 'gbp', symbol: '£' },
  // EUR countries
  AD: { country: 'AD', currency: 'eur', symbol: '€' },
  AT: { country: 'AT', currency: 'eur', symbol: '€' },
  BE: { country: 'BE', currency: 'eur', symbol: '€' },
  BG: { country: 'BG', currency: 'eur', symbol: '€' },
  CY: { country: 'CY', currency: 'eur', symbol: '€' },
  CZ: { country: 'CZ', currency: 'eur', symbol: '€' },
  DE: { country: 'DE', currency: 'eur', symbol: '€' },
  DK: { country: 'DK', currency: 'eur', symbol: '€' },
  EE: { country: 'EE', currency: 'eur', symbol: '€' },
  ES: { country: 'ES', currency: 'eur', symbol: '€' },
  FI: { country: 'FI', currency: 'eur', symbol: '€' },
  FR: { country: 'FR', currency: 'eur', symbol: '€' },
  GR: { country: 'GR', currency: 'eur', symbol: '€' },
  HR: { country: 'HR', currency: 'eur', symbol: '€' },
  HU: { country: 'HU', currency: 'eur', symbol: '€' },
  IE: { country: 'IE', currency: 'eur', symbol: '€' },
  IT: { country: 'IT', currency: 'eur', symbol: '€' },
  LT: { country: 'LT', currency: 'eur', symbol: '€' },
  LU: { country: 'LU', currency: 'eur', symbol: '€' },
  LV: { country: 'LV', currency: 'eur', symbol: '€' },
  MC: { country: 'MC', currency: 'eur', symbol: '€' },
  ME: { country: 'ME', currency: 'eur', symbol: '€' },
  MT: { country: 'MT', currency: 'eur', symbol: '€' },
  NL: { country: 'NL', currency: 'eur', symbol: '€' },
  PT: { country: 'PT', currency: 'eur', symbol: '€' },
  RO: { country: 'RO', currency: 'eur', symbol: '€' },
  SE: { country: 'SE', currency: 'eur', symbol: '€' },
  SI: { country: 'SI', currency: 'eur', symbol: '€' },
  SK: { country: 'SK', currency: 'eur', symbol: '€' },
  SM: { country: 'SM', currency: 'eur', symbol: '€' },
  VA: { country: 'VA', currency: 'eur', symbol: '€' },
  XK: { country: 'XK', currency: 'eur', symbol: '€' },
  // PLN countries
  PL: { country: 'PL', currency: 'pln', symbol: 'zł' },
  // AUD countries
  AU: { country: 'AU', currency: 'aud', symbol: 'AU$' },
  // CAD countries
  CA: { country: 'CA', currency: 'cad', symbol: 'CA$' },
  // MXN countries
  MX: { country: 'MX', currency: 'mxn', symbol: 'MX$' },
  // SAR countries
  SA: { country: 'SA', currency: 'sar', symbol: '﷼' },
  // EGP countries
  EG: { country: 'EG', currency: 'egp', symbol: 'E£' },
  // INR countries
  IN: { country: 'IN', currency: 'inr', symbol: '₹' },
  // USD defaults for all other countries
  // Tier 1 countries
  MY: { country: 'MY', currency: 'usd', symbol: '$' },
  VN: { country: 'VN', currency: 'usd', symbol: '$' },
  PH: { country: 'PH', currency: 'usd', symbol: '$' },
  NG: { country: 'NG', currency: 'usd', symbol: '$' },
  ID: { country: 'ID', currency: 'usd', symbol: '$' },
  KE: { country: 'KE', currency: 'usd', symbol: '$' },
  KZ: { country: 'KZ', currency: 'usd', symbol: '$' },
  PK: { country: 'PK', currency: 'usd', symbol: '$' },
  BD: { country: 'BD', currency: 'usd', symbol: '$' },
  // Tier 2 countries
  TR: { country: 'TR', currency: 'usd', symbol: '$' },
  JP: { country: 'JP', currency: 'usd', symbol: '$' },
  ZA: { country: 'ZA', currency: 'usd', symbol: '$' },
  BR: { country: 'BR', currency: 'usd', symbol: '$' },
  MA: { country: 'MA', currency: 'usd', symbol: '$' },
} as const;

export type StripeCountry = (typeof StripeCountryCurrency)[keyof typeof StripeCountryCurrency]['country'];
export type StripeCurrencyCode = (typeof StripeCountryCurrency)[keyof typeof StripeCountryCurrency]['currency'];
export type StripeCurrencySymbol = (typeof StripeCountryCurrency)[keyof typeof StripeCountryCurrency]['symbol'];

export const StripeTaxBehavior = {
  INCLUSIVE: 'inclusive',
  EXCLUSIVE: 'exclusive',
  UNSPECIFIED: 'unspecified',
} as const;

export type StripeTaxBehavior = (typeof StripeTaxBehavior)[keyof typeof StripeTaxBehavior];
